const question = (value) => (value ? 'declined' : {});

export default question;
